export enum OnboardingTypeEnum {
    Discover = "Discover",
    Intro = "Intro",
    StepByStep = "StepByStep",
    Tooltip = "Tooltip",
    WhatsNew = "WhatsNew",
}
